import { render, staticRenderFns } from "./createSala.vue?vue&type=template&id=7379de8e&scoped=true&"
import script from "./createSala.vue?vue&type=script&lang=js&"
export * from "./createSala.vue?vue&type=script&lang=js&"
import style0 from "./createSala.vue?vue&type=style&index=0&id=7379de8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7379de8e",
  null
  
)

export default component.exports